import './BuilderRules.scss';
import { v4 as uuid } from 'uuid';
import { RulesConstants, RulesTracks } from 'modules/application/detail/attendance/rules/RulesConstants';
import { debounce } from 'data/function';
import { ToastType } from 'modules/application/misc/ToastService';
import { QueuesTracks } from 'modules/application/detail/attendance/queueManagement/QueueManagementConstants';
import { AttendanceConstants } from 'modules/application/detail/attendance/AttendanceConstants';
export class BuilderRulesController {
    static $inject = ['$scope', 'DeskConfigurationService', 'AlertService', 'SegmentService', 'RulesService', 'QueuesService', '$translate', 'LoadValues', 'PermissionsService', 'TeamService'];
    constructor($scope, DeskConfigurationService, AlertService, SegmentService, RulesService, QueuesService, $translate, LoadValues, PermissionsService, TeamService) {
        'ngInject';
        this.$scope = $scope;
        this.DeskConfigurationService = DeskConfigurationService;
        this.AlertService = AlertService;
        this.SegmentService = SegmentService;
        this.RulesService = RulesService;
        this.QueuesService = QueuesService;
        this.$translate = $translate;
        this.LoadValues = LoadValues;
        this.PermissionsService = PermissionsService;
        this.TeamService = TeamService;
        this.isLoading = false;
        this.rules = [];
        this.filteredRules = [];
        this.rulesCount = 0;
        this.filteredRulesCount = 0;
        this.source = RulesTracks.SOURCE.BUILDER;
        this.inputTextSearchRules = '';
        this.isQueueManagementView = true;
        this.currentState = RulesConstants.STATES.VIEWING;
        this.isViewing = RulesConstants.STATES.VIEWING;
        this.isAdding = RulesConstants.STATES.ADDING;
        this.isEdit = RulesConstants.STATES.EDITING;
        this.itemsPerPage = 10;
        this.perPageAux = 0;
        this.hasInitialized = false;
        this.attendantsTake = 999999;
        this.attendants = [];
        this.skip = 0;
        this.filter = '';
        this.searchRule = async (event) => {
            this.inputTextSearchRules = event.detail.value;
            this.setIsLoading(true);
            if (this.inputTextSearchRules) {
                this.filterRules();
            }
            else {
                this.filteredRules = this.rules.slice();
                this.filteredRulesCount = this.rulesCount;
                this.checkLoadMoreStatus();
            }
            this.setIsLoading(false);
            this.SegmentService.createBotTrack(RulesTracks.RULES_SEARCHED, this.application, this.trackPayload);
        };
        this.changeTitle = async (event) => {
            const title = event?.detail?.value.trim() ?? '';
            if (!title) {
                this.QueuesService.showToast('queue-management.errors.emptyFieldErrorMessage', ToastType.Warning);
                return;
            }
            const queues = await this.getQueues();
            const queueFilter = queues.find(queue => {
                return queue.name.toLowerCase() === title.toLowerCase();
            });
            if (queueFilter) {
                if (!this.queue.id || this.queue.id != queueFilter.id) {
                    this.QueuesService.showToast('queue-management.queues.warnningEdit', ToastType.Warning);
                    return;
                }
            }
            if (AttendanceConstants.DIRECT_TRANSFER_TEAM.toLowerCase() === title.toLowerCase()) {
                this.QueuesService.showToast('queue-management.queues.warnningCreateQueue', ToastType.Warning);
                return;
            }
            this.queue.name = title;
            await this.saveQueue(this.queue);
        };
    }
    async $onInit() {
        if (this.isLoading) {
            return;
        }
        this.setIsLoading(true);
        this.debouncedSearch = debounce(this.searchRule, 500);
        await this.getAllAttendants();
        await this.getQueue();
        if (this.queue.id != '') {
            await this.fetchRules();
        }
        const [properties, relations, operators, teams, hasDeskWritePermission] = await Promise.all([
            this.LoadValues.loadProperties(),
            this.LoadValues.loadRelations(),
            this.LoadValues.loadOperators(),
            this.RulesService.fetchTeams(this.application),
            this.PermissionsService.hasPermissions(RulesConstants.WRITE, RulesConstants.DESK),
        ]);
        this.properties = properties;
        this.relations = relations;
        this.operators = operators;
        this.teams = teams;
        this.hasDeskWritePermission = hasDeskWritePermission;
        this.trackPayload = { source: RulesTracks.SOURCE.BUILDER };
        this.SegmentService.createBotTrack(RulesTracks.PAGE_OPENED, this.application, this.trackPayload);
        this.setIsLoading(false);
        this.hasInitialized = true;
    }
    setCurrentState(state) {
        this.currentState = state;
    }
    setIsLoading(isLoading) {
        this.isLoading = isLoading;
    }
    cancelAction(index) {
        if (this.currentState === RulesConstants.STATES.ADDING) {
            this.filteredRules.splice(index, 1);
            this.filteredRulesCount = this.filteredRules.length;
            this.queue.numberRules = this.filteredRulesCount;
        }
        else if (this.currentState === RulesConstants.STATES.EDITING) {
            this.changeStatusItem(index);
        }
        this.setCurrentState(RulesConstants.STATES.VIEWING);
    }
    async getQueue() {
        this.queue = await this.QueuesService.getQueue(this.queueId);
        this.queue.numberAttendants = (this.attendants.filter((a) => (a.teams.includes(this.queue.name)))).length || 0;
        this.queue.numberRules = 0;
    }
    async getAllAttendants() {
        try {
            const { items, total } = await this.TeamService.getAttendants(this.filter, this.skip, this.attendantsTake);
            const team = items;
            this.attendants.push(...team);
        }
        catch (e) {
            this.attendants = [];
        }
    }
    async editRule(index) {
        this.setCurrentState(RulesConstants.STATES.EDITING);
        await this.changeStatusItem(index);
    }
    async changeStatusItem(index) {
        this.filteredRules[index].opened = !this.filteredRules[index].opened;
    }
    async filterRules() {
        this.setIsLoading(true);
        try {
            const { rules, total } = await this.RulesService.filterRulesByQueue(this.queue.name, this.inputTextSearchRules, this.skip, this.itemsPerPage);
            if (this.hasAnyDistinctRule(rules, this.filteredRules)) {
                this.filteredRules = rules;
            }
        }
        catch (e) {
            this.filteredRules = [];
        }
        finally {
            this.filteredRulesCount = this.filteredRules.length;
            this.setIsLoading(false);
            this.checkLoadMoreStatus();
        }
    }
    hasAnyDistinctRule(rules, rulesToCompare) {
        if (rules.length != rulesToCompare.length) {
            return true;
        }
        return rules.some((q) => rulesToCompare.find((rtc) => rtc.id == q.id) === undefined);
    }
    checkLoadMoreStatus() {
        if (this.isFilterMode()) {
            this.canLoadMore = this.filteredRules.length < this.filteredRulesCount;
        }
        else {
            this.canLoadMore = this.rules.length < this.rulesCount;
        }
    }
    isFilterMode() {
        if (this.inputTextSearchRules == undefined || this.inputTextSearchRules === '') {
            return false;
        }
        return true;
    }
    async clearSearch() {
        this.setIsLoading(true);
        this.inputTextSearchRules = '';
        this.currentState = RulesConstants.STATES.VIEWING;
        await this.fetchRules();
        this.checkLoadMoreStatus();
        this.SegmentService.createBotTrack(RulesTracks.CLEAR_SEARCH, this.application, this.trackPayload);
        this.setIsLoading(false);
    }
    async createRule() {
        const title = await this.$translate('builder-attendance-rules.rules.ruleName');
        const newRule = {
            id: uuid(),
            title: `${title} ${this.filteredRules.length + 1}`,
            conditions: [{
                    property: 'Message',
                    relation: 'Contains',
                    values: [],
                }],
            team: this.queue.name,
            isActive: true,
            opened: true,
            operator: RulesConstants.DEFAULT_OPERATOR,
            repeatConditionsBody: false,
        };
        this.filteredRulesCount = this.filteredRules.unshift(newRule);
        this.setCurrentState(this.isAdding);
        this.queue.numberRules = this.filteredRulesCount;
        const input = document.getElementById(`rule-title-${this.filteredRules.length - 1}`);
        if (input) {
            input.focus();
            this.filteredRules[this.filteredRules.length - 1].opened = true;
        }
        this.SegmentService.createBotTrack(RulesTracks.RULE_ADDED, this.application, this.trackPayload);
    }
    async saveRule(rule) {
        try {
            await this.RulesService.set(this.application, rule);
            const isInsertingRule = !this.ruleExistis(rule, this.rules);
            if (isInsertingRule) {
                this.filteredRules = [...this.filteredRules.slice(1), rule];
                this.rules.push(rule);
                this.rulesCount = this.rules.length;
            }
            else {
                this.updateRule(rule, this.rules);
                this.updateRule(rule, this.filteredRules);
            }
            const toastMessageReference = this.currentState === RulesConstants.STATES.ADDING
                ? 'attendance-rules.rules.confirmAddRule'
                : 'attendance-rules.rules.confirmEdit';
            this.RulesService.showToast(toastMessageReference, ToastType.Success);
            this.SegmentService.createBotTrack(RulesTracks.RULE_SAVED, this.application, this.trackPayload);
            this.setCurrentState(this.isViewing);
        }
        catch (ex) {
            const errorMsg112 = 'utils.errorMsg.112';
            this.RulesService.showToast(errorMsg112, ToastType.Danger);
        }
    }
    ruleExistis(newRule, rules) {
        return rules.map(r => r.id).indexOf(newRule.id) != -1;
    }
    updateRule(rule, rules) {
        const index = rules.map(r => r.id).indexOf(rule.id);
        rules[index] = rule;
    }
    async toggleRule(rule) {
        await this.RulesService.set(this.application, rule);
    }
    async confirmDelete(rule) {
        try {
            const modalTitle = await this.$translate('modules.application.detail.attendance.rules.builder.confirmDeleteTitle');
            const modalBody = await this.$translate('modules.application.detail.attendance.rules.builder.confirmDeleteBody');
            const confirm = await this.$translate('utils.forms.exclude');
            const cancel = await this.$translate('utils.forms.cancel');
            await this.AlertService.show({
                title: modalTitle,
                body: modalBody,
                variant: 'delete',
                icon: 'trash',
                buttons: {
                    cancel: cancel,
                    confirm: confirm,
                },
                callback: {
                    cancelButtonAction: () => {
                    },
                    confirmButtonAction: () => this.delete(rule),
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async delete(rule) {
        let toastType;
        let messageTranslationKey;
        try {
            this.setIsLoading(true);
            await this.RulesService.delete(rule);
            const newRules = this.filteredRules.filter(t => t.id !== rule.id);
            this.rules = newRules;
            this.filteredRules = this.rules.slice();
            this.rulesCount = newRules.length;
            this.filteredRulesCount = newRules.length;
            this.queue.numberRules = newRules.length;
            this.setCurrentState(this.isViewing);
            messageTranslationKey = 'utils.successMsg.31';
            toastType = ToastType.Success;
            this.SegmentService.createBotTrack(RulesTracks.RULE_DELETED, this.application, this.trackPayload);
        }
        catch (e) {
            messageTranslationKey = 'utils.errorMsg.113';
            toastType = ToastType.Danger;
        }
        finally {
            this.RulesService.showToast(messageTranslationKey, toastType);
            this.setIsLoading(false);
        }
    }
    isAnyRuleOpen() {
        return this.filteredRules.some(r => r.opened);
    }
    async fetchRules() {
        try {
            this.inputTextSearchRules = '';
            this.rules = [];
            const { rules, total } = await this.RulesService.getRulesQueue(this.queue.name, this.perPageAux, this.itemsPerPage);
            this.rules.push(...rules);
            this.filteredRules = this.rules.slice();
            this.rulesCount = total ?? 0;
            this.filteredRulesCount = this.rulesCount;
            this.queue.numberRules = this.rulesCount;
            this.checkLoadMoreStatus();
        }
        catch (e) {
            console.error(e);
        }
    }
    async loadMore() {
        if (this.isFilterMode()) {
            const { rules, total } = await this.RulesService.filterRulesByQueue(this.queue.name, this.inputTextSearchRules, this.filteredRules.length, this.itemsPerPage);
            this.filteredRules.push(...rules);
            this.filteredRulesCount = total;
            this.checkLoadMoreStatus();
        }
        else {
            const { rules, total } = await this.RulesService.getRulesQueue(this.queue.name, this.rules.length, this.itemsPerPage);
            this.rules.push(...rules);
            this.rulesCount = total;
            this.filteredRulesCount = total;
            this.filteredRules = this.rules.slice();
            this.checkLoadMoreStatus();
        }
    }
    async confirmDeleteQueue(queue) {
        if (queue.numberAttendants > 0) {
            let toastMessageReference;
            let toastType;
            toastType = ToastType.Danger;
            toastMessageReference = 'queue-management.queues.warnningDeleteAttendant';
            await this.QueuesService.showToast(toastMessageReference, toastType);
            return;
        }
        try {
            const modalTitle = await this.$translate('modules.application.detail.attendance.queue-management.builder.confirmDeleteTitle');
            const modalBody = await this.$translate('modules.application.detail.attendance.queue-management.builder.confirmDeleteBody', { name: queue.name });
            const confirm = await this.$translate('utils.forms.exclude');
            const cancel = await this.$translate('utils.forms.cancel');
            await this.AlertService.show({
                title: modalTitle,
                body: modalBody,
                variant: 'delete',
                icon: 'trash',
                buttons: {
                    cancel: cancel,
                    confirm: confirm,
                },
                callback: {
                    cancelButtonAction: () => { },
                    confirmButtonAction: () => this.deleteQueue(queue),
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async deleteQueue(queue) {
        let toastMessageReference;
        let toastType;
        try {
            this.setIsLoading(true);
            await this.QueuesService.delete(queue);
            toastMessageReference = 'queue-management.queues.confirmRemoveQueue';
            toastType = ToastType.Success;
            this.SegmentService.createBotTrack(QueuesTracks.QUEUE_DELETED, this.application, this.trackPayload);
        }
        catch (e) {
            toastMessageReference = 'utils.errorMsg.113';
            toastType = ToastType.Danger;
        }
        finally {
            this.setIsLoading(true);
            await this.QueuesService.showToast(toastMessageReference, toastType);
            this.backToQueueMode();
        }
    }
    backToQueueMode() {
        this.changeMode();
    }
    isQueueNameEditable() {
        return this.queue.numberAttendants === 0 && this.queue.numberRules === 0 && this.hasDeskWritePermission;
    }
    openErrorEditToast() {
        if (this.queue.numberAttendants > 0) {
            this.QueuesService.showToast('queue-management.queues.warnningEditAttendant', ToastType.Warning);
            return;
        }
        if (this.queue.numberRules > 0) {
            this.QueuesService.showToast('queue-management.queues.warningEditRules', ToastType.Warning);
            return;
        }
    }
    async getQueues() {
        if (this.isLoading) {
            return;
        }
        this.setIsLoading(true);
        this.canLoadMore = false;
        try {
            const { items } = await this.QueuesService.getQueues(this.perPageAux, this.itemsPerPage);
            return items;
        }
        catch (e) {
            return [];
        }
        finally {
            this.setIsLoading(false);
        }
    }
    async saveQueue(data) {
        this.setIsLoading(true);
        let toastMessageReference = 'queue-management.queues.confirmEdit';
        let toastType;
        try {
            await this.QueuesService.save(data);
            this.SegmentService.createBotTrack(QueuesTracks.QUEUE_SAVED, this.application, this.trackPayload);
            toastType = ToastType.Success;
            return true;
        }
        catch (ex) {
            if (ex.code === 23) {
                toastMessageReference = 'utils.errorMsg.177';
                toastType = ToastType.Danger;
            }
            else {
                toastMessageReference = 'modules.application.detail.attendance.queue-management.warning';
                toastType = ToastType.Danger;
            }
            return false;
        }
        finally {
            await this.QueuesService.showToast(toastMessageReference, toastType);
            this.setIsLoading(false);
            this.queueName = data.name;
            this.queueId = data.id;
            this.queue = data;
        }
    }
}
BuilderRulesController.$inject = ['$scope', 'DeskConfigurationService', 'AlertService', 'SegmentService', 'RulesService', 'QueuesService', '$translate', 'LoadValues', 'PermissionsService', 'TeamService'];
